
    export default {
        data() {
            return {

            }
        },
        mounted() {
            document.querySelector('html').style.overflowY = 'hidden';
        },
        destroyed() {
            document.querySelector('html').style.overflowY = 'visible';
        },
        methods: {
            closeModal() {
                this.$store.commit('modal/setDisplayMobileFilter', {isOpen: false, mode: ''})
                window.scrollTo(0,0);
            }
        },
        computed: {
            isOpen() {
                return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
            },
            mode() {
                return this.$store.getters['modal/showDisplayMobileFilter'].mode
            },
        }
    }
